'use client';

import { ReactLenis } from 'lenis/react';
import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import { ThemeProvider, useTheme } from '@mui/material';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v14-appRouter';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns as DateAdapter } from '@mui/x-date-pickers-pro/AdapterDateFnsV3';
import { theme } from '@/styles/theme';

export interface AppProvidersProps {
    children?: React.ReactNode;
}

// Reference for Lenis: https://medium.com/@iamyuvraj456/elegant-scrolling-in-next-js-2d7f3fb4c8e1

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => (
    <AppRouterCacheProvider options={{ enableCssLayer: true }}>
        <LocalizationProvider dateAdapter={DateAdapter}>
            <ThemeProvider theme={theme}>
                <ParallaxProvider>
                    <SiteGlobalStyles />
                    <ReactLenis root options={{ lerp: 0.1, duration: 1.5, smoothWheel: true }}>
                        {children}
                    </ReactLenis>
                </ParallaxProvider>
            </ThemeProvider>
        </LocalizationProvider>
    </AppRouterCacheProvider>
);

const SiteGlobalStyles = () => {
    const theme = useTheme();
    const scrollPadding = theme.settings.appBar.spacer(2);
    return (
        <>
            <CssBaseline enableColorScheme={true} />
            <GlobalStyles
                styles={{
                    'html, body': {
                        height: 'auto',
                    },
                    html: {
                        [theme.breakpoints.up('xxl')]: { scrollPaddingTop: scrollPadding.xxl },
                        [theme.breakpoints.up('xl')]: { scrollPaddingTop: scrollPadding.xl },
                        [theme.breakpoints.only('lg')]: { scrollPaddingTop: scrollPadding.lg },
                        [theme.breakpoints.only('md')]: { scrollPaddingTop: scrollPadding.md },
                        [theme.breakpoints.only('sm')]: { scrollPaddingTop: scrollPadding.sm },
                        [theme.breakpoints.only('xs')]: { scrollPaddingTop: scrollPadding.xs },
                    },
                }}
            />
        </>
    );
};
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    (window as unknown as { theme: unknown }).theme = theme;
}
